<template>
    <div>
        <v-card elevation="0" outlined>
            <!--Homecard Images-->
            <v-img
                height="170"
                src="../../../assets/backgrounds/morning.jpg"
                v-if="timeofday == 'morning'"
            >
                <v-card-text>
                    <v-card-title class="text-h5 white--text">
                        {{ getTime+getUserInfo }}!
                    </v-card-title>
                    <v-card-subtitle class="text-h6 white--text">
                        <b>Student Number: {{ getStudentNo }}</b>
                    </v-card-subtitle>
                    
                </v-card-text>
            </v-img>
            <v-img
                height="170"
                src="../../../assets/backgrounds/afternoon.jpg"
                v-else-if="timeofday == 'afternoon'"
            >
                <v-card-text>
                    <v-card-title class="text-h5 white--text">
                        {{ getTime+getUserInfo }}!
                    </v-card-title>
                    <v-card-subtitle class="text-h6 white--text">
                        <b>Student Number: {{ getStudentNo }}</b>
                    </v-card-subtitle>
                </v-card-text>
            </v-img>
            <v-img
                height="170"
                src="../../../assets/backgrounds/night.png"
                v-else-if="timeofday == 'evening'"
                position="top center"
            >
                <v-card-text>
                    <v-card-title class="text-h5 white--text">
                        {{ getTime+getUserInfo }}!
                    </v-card-title>
                    <v-card-subtitle class="text-h6 white--text">
                        <b>Student Number: {{ getStudentNo }}</b>
                    </v-card-subtitle>
                </v-card-text>
            </v-img>
            <!--End of Homecard Images-->
        </v-card>
        <v-alert
            dark
            color="#FFB300"
        >
            If your student number above is not correct/not shown, or if you have any issues with the statements, 
            please contact Student Financial Services via contacts below.
        </v-alert>
        <br /><br />
        <v-row>
            <v-col sm="6">
                <v-card class="fill-height" elevation="1">
                    <v-toolbar elevation="1" dark color="#29A0B1">
                        <v-toolbar-title>Contact Us:</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-icon>mdi-email-outline</v-icon>&nbsp;<b>Email:</b>&nbsp;<a href="mailto:studentfinance@kings.uwo.ca">studentfinance@kings.uwo.ca</a> <br /><br />
                        <v-icon>mdi-cellphone</v-icon>&nbsp;<b>Tel:</b>&nbsp;<a href="tel:519-433-3491">519-433-3491</a> ext. 4319
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-toolbar elevation="1" dark color="#29A0B1">
                        <v-toolbar-title>Useful Links:</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-icon>mdi-information-box-outline</v-icon>&nbsp;<b>:</b>&nbsp;<a href="https://www.kings.uwo.ca/current-students/money-matters/">Money Matters</a> <br />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import auth from '../../../js/auth.js';
export default {
    name: "homecard",
    data(){
        return {
            timeofday: "morning"
        }
    },
    computed: {
        getUserInfo() {
            let user = {}
            let firstname = ""
            if(sessionStorage.getItem("sfs_asss")){
                user = JSON.parse(sessionStorage.getItem("sfs_asss"));
                firstname = user["firstname"];
            }else {
                user = auth.get_user();
                firstname = user["name"];
            }

          return firstname
        },
        getStudentNo(){
            let user = {}
            if(sessionStorage.getItem("sfs_asss")){
                user = JSON.parse(sessionStorage.getItem("sfs_asss"));
            }else {
                user = auth.get_user();
            }

            if(user["dev"]){
                return user["dev"]
            }else if(user["employeeNumber"]){
                return user["employeeNumber"]
            }else {
                return user["emplid"]
            }
        },
        getTime(){
            let date = new Date();
            let hour = date.getHours();

            if (hour >= 12 && hour < 18) {
                return "Good Afternoon, ";
            } else if (hour >= 18 && hour < 24) {
                return "Good Evening, ";

            }

            return "Good Morning, ";
        }
    },
    methods: {
        getTimeOftheDay(){
            const that = this;
            let date = new Date();
            let hour = date.getHours();

            if (hour >= 12 && hour < 18) {
                that.timeofday = "afternoon";
            } else if (hour >= 18 && hour < 24) {
                that.timeofday = "evening"
            }else {
                that.timeofday = "morning"
            }
        }
    },
    created(){
        const that = this;
        that.getTimeOftheDay();
    }
}
</script>